import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SearchInput from "./components/search-input.vue";
import ContentList from "./components/content-list/content-list.vue";
import { onMounted, ref } from "vue";
import { request } from "./api/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const formData = ref({});
const onSearch = (data) => {
  formData.value = { ...data };
};
const onReset = () => {
  const data = { city: "", search: "" };
  formData.value = { ...data };
};

onMounted(() => {
  request("web.basicBiz.address.getMultiLevelSubList", {
    districtLevel: "province",
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SearchInput, {
      onSearch: onSearch,
      onReset: onReset
    }),
    _createVNode(ContentList, {
      city: formData.value.city,
      jobName: formData.value.search
    }, null, 8, ["city", "jobName"])
  ], 64))
}
}

})